import { render, staticRenderFns } from "./ProofreadCurriculumUnits.vue?vue&type=template&id=72d278ab&scoped=true&lang=pug&"
import script from "./ProofreadCurriculumUnits.vue?vue&type=script&lang=ts&"
export * from "./ProofreadCurriculumUnits.vue?vue&type=script&lang=ts&"
import style0 from "./ProofreadCurriculumUnits.vue?vue&type=style&index=0&id=72d278ab&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d278ab",
  null
  
)

export default component.exports